import { FavouriteLocationSummary } from 'types/markerTypes/location.favourites.js';

export interface IFavouritesState {
  topItems: FavouriteLocationSummary[];
  bottomItems: FavouriteLocationSummary[];
  allItems: FavouriteLocationSummary[];
  favsAdded: boolean;
}

// Interface for the list of favourites stored in LocalStorage
export interface IStoredFavourites {
  items: string[]; // Array of IDs of all the user's faves
  topCount: number; // Count of how many items from the head of the array should be considered as the user's 'top faves'
}

export const FAVOURITES_KEY = 'favourites';
export const MAX_TOP_FAVOURITES = 3;
export const MAX_FAVOURITES_TO_SHOW = 8;

/**
 * Takes a ILocationSummary object and extracts the type and key to create a favourite key
 * that is used to request favourites from the favourites endpoint, along with storing the favourite's key in local storage
 * so they persist in the browser.
 * @param location an ILocationSummary object which every page should have
 */
export function createFavouriteApi({
  favouriteKey,
  favouriteType,
  key,
  type,
}: {
  favouriteKey?: FavouriteLocationSummary['favouriteKey'];
  favouriteType?: FavouriteLocationSummary['favouriteType'];
  key: string;
  type: string;
}): string {
  /**
   * NOTE: `favouriteType` attributes has been just introduced. So we fall back to `type`
   * to keep out mocks working.
   */
  return `${favouriteType || type}/${favouriteKey || key}`;
}
